import { useWebApp } from '@vkruglikov/react-telegram-web-app';

import { useEffect } from 'react';
import useStore from '../state/useStore';

export default function useBiometricManager() {
  const {
    bioAvailable,
    setBioAvailable,
    bioInited,
    setBioInited,
    bioAccessGranted,
    setBioAccessGranted,
  } = useStore();
  const WebApp = useWebApp();
  const biometryManager = WebApp?.BiometricManager;

  useEffect(() => {
    const bioInterval = setInterval(() => {
      if (bioInited != biometryManager?.isInited) {
        setBioInited(biometryManager?.isInited || false);
      }
      if (bioAvailable != biometryManager?.isBiometricAvailable) {
        setBioAvailable(biometryManager?.isBiometricAvailable || false);
      }
      if (bioAccessGranted != biometryManager?.isAccessGranted) {
        setBioAccessGranted(biometryManager?.isAccessGranted || false);
      }
    }, 200);
    if (!biometryManager?.isInited) {
      biometryManager?.init(function() {
        setBioInited(biometryManager?.isInited || false);
      });
    }
    return () => {
      clearInterval(bioInterval);
    };
  }, []);

  const requestAccess = ({
    reason = 'We will use biometry to protect your account',
    callback,
  }: {
    reason?: string;
    callback: (success: boolean) => void;
  }) => {
    if (!biometryManager?.isAccessGranted) {
      biometryManager?.requestAccess(
        {
          reason,
        },
        (success: boolean) => {
          setBioAccessGranted(success);
          callback(success);
        }
      );
      return;
    }
    callback(true);
  };

  const authenticate = ({
    reason = 'We need to authenticate you to continue',
    callback,
    failCallback,
  }: {
    reason?: string;
    callback: (success: boolean, token: string) => void;
    failCallback?: (error: Error) => void;
  }) => {
    if (!bioAvailable) {
      failCallback && failCallback(new Error('Biometry is not available'));
      return;
    }

    if (!bioInited) {
      failCallback && failCallback(new Error('Biometry is not inited'));
      return;
    }

    if (bioAccessGranted) {
      biometryManager?.authenticate(
        {
          reason,
        },
        callback
      );
      return;
    }

    requestAccess({
      callback: success => {
        if (!success) {
          failCallback &&
            failCallback(new Error('You must allow biometry to continue'));
          return;
        }

        biometryManager?.authenticate(
          {
            reason,
          },
          callback
        );
      },
    });
  };
  return {
    biometryManager,
    requestAccess,
    authenticate,
    bioAvailable,
    bioInited,
    bioAccessGranted,
  };
}
